/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

export const AvailableGaugePanels = Object.freeze({
  bas: 'bas',
  automated_chat: 'automated_chat',
  bes: 'bes',
  volume: 'volume',
});

export const CONFIG_KEY_MAPPER = Object.freeze({
  bas: 'bas',
  automated_chat: 'ac',
  bes: 'bes',
});

export const CONFIG_BENCHMARK_MAPPER = {
  bas: 'basBenchmark',
  automated_chat: 'acBenchmark',
  bes: 'besBenchmark',
};
